import { useEffect, useState } from 'react';

import { getReefById, Reef } from '../../../api/fishrules/getReefById';
import { reportMykissClientError } from '../../errorHandling/client';

interface Result {
  isLoading: boolean;
  reef?: Reef;
}

interface Params {
  fishrulesReefId: number;
}

export function useReefById(params: Params): Result {
  const [isLoading, setIsLoading] = useState(true);
  const [reef, setReef] = useState<Reef>();

  const fishrulesReefId = params.fishrulesReefId;

  useEffect(() => {
    const controller = new AbortController();
    setIsLoading(true);

    if (fishrulesReefId !== undefined) {
      getReefById({ fishrulesReefId }, controller.signal)
        .then(({ results, success }) => {
          if (success && results) {
            setReef(results);
          } else {
            setReef(undefined);
          }
          setIsLoading(false);
        })
        .catch(error => {
          if (error.name !== 'AbortError') {
            reportMykissClientError(error);
          }
          setIsLoading(false);
        });
    }

    return () => {
      controller.abort();
    };
  }, [fishrulesReefId]);

  return { isLoading, reef };
}
